export default {
  fr: {
    Title : 'Cash flow',
    Region : {
      Title : 'Régions',
      Name : 'Nom',
      IncomeTax : 'Taxe revenu',
      MiningTax : 'Taxe minière',
      AddNew : 'Nouvelle région',
      Edit : "Édition d'une région",
      Delete : "Suppression d'une region",
      RegionDeleted : "La région a été correctement supprimée",
      ConfirmDelete : "Souhaitez-vous réellement supprimer cette région?",
      AlreadyExists : "Une région avec le même nom existe déjà"
    },
    Project : {
      Title : 'Projets',
      Name : 'Nom',
      RegionName : 'Région',
      AddNew : 'Nouveau projet',
      Edit : "Édition d'un projet",
      Delete : "Suppression d'un projet",
      ProjectDeleted : "Le projet a été correctement supprimé",
      ConfirmDelete : "Souhaitez-vous réellement supprimer ce projet?"
    },
    Lom : {
      Title : 'Projet Modèles',
      Name : 'Nom',
      Version : 'Version',
      Description : 'Description',
      FileContent : 'Fichier Source',
      YearAdjustment : "Ajustement d'année (+/-)",
      Availability : 'Disponibilité',
      AvailabilityPublic : 'Publique',
      AvailabilityPrivate : 'Privée',
      UploadTemplateFile : 'Obtenir le modèle',
      UploadInvalidFileError : "Un fichier excel avec l'extension .xlsx doit être fourni.",
      ProjectMustBeCreated : 'Le modèle doit avoir été créé avant de téléverser un fichier',
      UploadCompleted : 'The téléversement est complété avec succès',
      AddNew : 'Nouveau modèle',
      Edit : "Édition d'un modèle",
      Delete : "Suppression d'un modèle",
      ConfirmDelete : "Souhaitez-vous réellement supprimer ce modèle?",
      LomDeleted : "Le modèle a été correctement supprimé",
      UploadInProgress : 'Téléversement du modèle en cours',
      UploadFile : "Fichier à téléverser",
      Tab1 : "Général",
      Tab2 : "Téléchargement"
    },
    ProjectLom : {
      Title : 'Modèle de projet',
      ExternalProjectName : 'Project',
      HyperionEntityName : 'Hyperion',
      ProjectName : 'Project',
      ProjectSource : 'Project Source'
    },
    CorporateLom : {
      Title : "Modèle d'entreprise"
    },
    LomType : {
      'Name' : "Type",
      '0' : "LOM",
      '1' : "ELOM",
      '2' : "Budget",
      '3' : "Extension",
      '4' : "Scénario d'évaluation",
      '5' : "FPM"
    },
    Currency : {
      'Name' : "Devise",
      '0' : "USD",
      '1' : "CAD",
      '2' : "EUR",
      '3' : "MXN",
      '4' : "AUD"
    },
    Compilation : {
      Title : 'Compilations',
      Name : 'Nom',
      Description : 'Description',
      Availability : 'Disponibilité',
      AvailabilityPublic : 'Publique',
      AvailabilityPrivate : 'Privée',
      CreatedBy : 'Créé par',
      CreationDate : 'Créé le',
      CalculationDate: "Calculé le",
      ModificationDate: "Modifié le",
      MyCompilation : "N'afficher que mes compilations",
      DiscountRate : 'Taux d’actualisation',
      ElementYearlyPriceTemplate : 'Modèle de prix par élément',
      YearlyInflationRateTemplate : 'Modèle de taux d’inflation',
      YearlyFxRateTemplate : 'Modèle de taux de change',
      UserList : 'Usagers',
      UserEmail : 'Courriel usager',
      AddNew : 'Nouvelle compilation',
      Edit : "Édition d'une compilation",
      Delete : "Suppression d'une compilation",
      ConfirmDelete : "Souhaitez-vous réellement supprimer cette compilation?",
      CompilationDeleted : "La compilation a été correctement supprimée",
      Tab1 : "Informations générales",
      Tab2 : "Modèles Inclus",
      Tab3 : "Paramètres de compilation",
      Tab4 : "Sécurité",
      NoDescription : "Aucune description",
      ExternalLOMS : "Modèles Externes",
      HyperionLOMS : "Modèles Hyperions",
      IncludedLOMS : "Modèles Inclus",
      IsDecarbonizationScenario : "Scénario de décarbonisation",
      ConfirmCalculate : "Souhaitez-vous réellement calculer cette compilation?",
      Calculate : "Calculer",
      SaveAndCalculate : "Enregistrer et Calculer",
      SendingRequest : "Envoi de la requête...",
      RequestSent : "Requête envoyé",
      Calculation : "Calcul en cours... Vérifiez l'état de la compilation dans Les tâches en cours dans le haut de l'écran.",
      CalculationCompleted : "Calcul complété",
      StartedAt : "Démarré à",
      CustomizeRatesButton : "Personnaliser les taux",
      CancelCustomizedRatesButton : "Annuler les taux personnalisés",
      Report : "Rapport"
    },
    Admin: {
      Title : "Admin"
    },
    Reports: {
      Title: "Rapport",
      LOM : "LOM",
      BackToCompilations : "Retour aux compilations"
    },
    ElementYearlyPriceTemplate:  {
      Title: "Modele de prix annuel par élément",
      Name : 'Nom',
      ConfirmDelete : "Souhaitez-vous réellement supprimer ce modèle",
      DeletedConfirmation : "Le modèle a été correctement supprimé",
      AddNew : 'Nouveau modèle',
      Edit : "Édition d'un modèle",
      Tab1Title: "Modèle",
      Tab2Title: "Prix par année/élément",
      Tab2Unavailable: "Les prix ne sont pas disponibles jusqu'à ce que le modèle soit sauvegardé"
    },
    ElementYearlyPrice:  {
      Title: "Prix annuel d'un élément",
      Price : 'Prix',
      Year : 'Année',
      StartYear : 'Année de début',
      EndYear : 'Année de fin',
      Element : 'Element',
      Total : "Total",
      ConfirmDelete : "Souhaitez-vous réellement supprimer ce prix",
      DeletedConfirmation : "Le prix a été correctement supprimé",
      BatchAddTitle: "Ajout de prix par année/élément",
      AddNew : 'Nouveaux prix',
      Edit : "Editer les prix"
    },
    YearlyFxRateTemplate:  {
      Title: "Modèle de taux de change annuel",
      Name : 'Nom',
      ConfirmDelete : "Souhaitez-vous réellement supprimer ce modèle",
      DeletedConfirmation : "Le modèle a été correctement supprimé",
      AddNew : 'Nouveau modèle',
      Edit : "Édition d'un modèle",
      Tab1Title: "Modèle",
      Tab2Title: "Taux de change par année/devise",
      Tab2Unavailable: "Les taux de change ne sont pas disponibles jusqu'à ce que le modèle soit sauvegardé"
    },
    YearlyFxRate:  {
      Title: "Taux de change annuel",
      Rate : 'Taux',
      OriginalRate : 'Taux du modèle: ',
      Year : 'Année',
      StartYear : 'Année de début',
      EndYear : 'Année de fin',
      Currency : 'Devise',
      ConfirmDelete : "Souhaitez-vous réellement supprimer ce taux",
      DeletedConfirmation : "Le taux a été correctement supprimé",
      BatchAddTitle: "Ajout de taux de change par année/devise",
      AddNew : 'Nouveaux taux',
      Edit : "Editer les taux"
    },
    YearlyInflationRateTemplate:  {
      Title: "Modèle d'inflation annuel",
      Name : 'Nom',
      ConfirmDelete : "Souhaitez-vous réellement supprimer ce modèle",
      DeletedConfirmation : "Le modèle a été correctement supprimé",
      AddNew : 'Nouveau modèle',
      Edit : "Édition d'un modèle",
      Tab1Title: "Modèle",
      Tab2Title: "Taux d'inflation par année/catégorie",
      Tab2Unavailable: "Les taux d'inflation ne sont pas disponibles jusqu'à ce que le modèle soit sauvegardé"
    },
    YearlyInflationRate:  {
      Title: "Inflation annuelle",
      Rate : 'Taux',
      OriginalRate : 'Taux du modèle: ',
      Year : 'Année',
      StartYear : 'Année de début',
      EndYear : 'Année de fin',
      Category : 'Catégorie',
      ConfirmDelete : "Souhaitez-vous réellement supprimer ce taux",
      DeletedConfirmation : "Le taux a été correctement supprimé",
      BatchAddTitle: "Ajout de taux par année/catégorie",
      AddNew : 'Nouveaux taux',
      Edit : "Editer les taux"
    },
    InflationCategory : {
      'Name' : "Catégories d'inflation",
      '0' : "Open Pit Costs",
      '1' : "Underground Costs",
      '2' : "Heap Leach Costs",
      '3' : "Mill Costs",
      '4' : "Site Costs",
      '5' : "Sustaining Capital",
      '6' : "Growth Capital"
    }
  }
}
